import {
  sendGetRequest,
  sendDeleteRequest,
  sendPutRequest,
  sendPostRequest
} from '../requests';

const baseUrl = '/treatment-categories';

export const getAllTreatmentCategories = () =>
  sendGetRequest(baseUrl);

export const getAllTreatments = () =>
  sendGetRequest(`${baseUrl}/treatment-groups/treatments`);

export const deleteCategory = (id: number) =>
  sendDeleteRequest(`${baseUrl}/${id}`);

export const deleteGroup = (id: number) =>
  sendDeleteRequest(`${baseUrl}/treatment-groups/${id}`);

export const deleteTreatment = (id: number) =>
  sendDeleteRequest(`${baseUrl}/treatment-groups/treatments/${id}`);

export const updateCategory = (id: number, body) =>
  sendPutRequest(`${baseUrl}/${id}`, body);

export const updateGroup = (id: number, body) =>
  sendPutRequest(`${baseUrl}/treatment-groups/${id}`, body);

export const updateTreatment = (id: number, body) =>
  sendPutRequest(`${baseUrl}/treatment-groups/treatments/${id}`, body);

export const createCategory = (body) =>
  sendPostRequest(baseUrl, body);

export const createGroup = (id: number, body) =>
  sendPostRequest(`${baseUrl}/${id}/treatment-groups`, body);

export const createTreatment = (id: number, body) =>
  sendPostRequest(`${baseUrl}/treatment-groups/${id}/treatments`, body);
